import { render, staticRenderFns } from "./fuelchargelist.vue?vue&type=template&id=4b5b8197&"
import script from "./fuelchargelist.vue?vue&type=script&lang=js&"
export * from "./fuelchargelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports